import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/Layout.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/login", name: "Login", component: () => import("../views/Login.vue") },
  {
    path: "/",
    component: Layout,
    redirect: "/ad-slots",
    children: [
      { path: "ad-slots", name: "AdSlots", component: () => import("../views/adSlot/AdSlotList.vue"), meta: { title: "广告位管理" } },
      { path: "users", name: "Users", component: () => import("../views/user/UserList.vue"), meta: { title: "用户管理" } },
      { path: "users/:id", name: "UserDetail", component: () => import("../views/user/UserDetail.vue"), meta: { title: "用户详情" } },
      { path: "questions", name: "Questions", component: () => import("../views/question/QuestionList.vue"), meta: { title: "题库管理" } },
      { path: "ad-view-records", name: "AdViewRecords", component: () => import("../views/adViewRecord/AdViewRecordList.vue"), meta: { title: "广告核销记录" } },
      { path: "app-versions", name: "AppVersions", component: () => import("../views/version/VersionManage.vue"), meta: { title: "版本管理" } },
    ],
  },
];

const router = new VueRouter({ mode: "history", routes });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("admin_token");
  if (to.path === "/login") {
    next();
  } else if (!token) {
    next("/login");
  } else {
    next();
  }
});

export default router;
